import { useState } from 'react';

export const useVideo = (video) => {
  const [ percent, setPercent ] = useState(0);
  const [ playing, setPlaying ] = useState(false);

  const onPlay = () => {
    video.play();
    setPlaying(true);
  };

  const onPause = () => {
    video.pause();
    setPlaying(false);
  };

  const onEnded = () => {
    video.autoplay = false;
    video.load();
  };

  const onTimeupdate = () => {
    const { duration, currentTime } = video;
    const percent = Math.ceil(currentTime * 100 / duration);

    setPercent(percent);
  };

  return [
    percent,
    playing,
    onPlay,
    onPause,
    onEnded,
    onTimeupdate
  ];
};